import { UseQueryResult } from "@tanstack/react-query"
import { useMemo } from "react"

import {
  getEventsFromCategory,
  EventsResponses,
} from "@costory/types/endpoints/events"
import { EventCategory } from "@costory/types/prisma-client"

type EventCounts = {
  business: number
  technical: number
  provider: number
}

export const useEventCounts = (
  eventsQuery: UseQueryResult<EventsResponses.Aggregated>,
): EventCounts => {
  return useMemo(() => {
    if (!eventsQuery.data) return { business: 0, technical: 0, provider: 0 }

    const calculateEventCount = (category: EventCategory) => {
      const events = getEventsFromCategory(eventsQuery.data!, category)
        .map((el) => el.events)
        .flat()
      return events.length
    }

    return {
      business: calculateEventCount(EventCategory.BUSINESS),
      technical: calculateEventCount(EventCategory.TECHNICAL),
      provider: calculateEventCount(EventCategory.PROVIDER),
    }
  }, [eventsQuery.data])
}
